export class IdentityUser {
	roles: string[];
	userId: string;
	firstName: string;
	lastName: string;
	email: string;
	openAddRole: boolean; //from js
	status: string;
	owner: string;

	constructor() {
		this.roles = [];
		this.userId = '';
		this.firstName = '';
		this.lastName = '';
		this.email = '';
		this.openAddRole = false;
		this.status = '';
		this.owner = '';
	}
}
